import { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA, textFormatEditor } from "../../../../../utils/commonFunctions";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";

const useColumnDefs = () => {
  

  const IndustryNameColumn: ColDef = {
    field: "industry_name",
    headerName: "Industry Name",
    cellRenderer: (props: any) => {
      return renderNA(props.data.industry_name);
    },
  };
  // const IndustryCategory: ColDef = {
  //   field: "category.name",
  //   headerName: "Category",
  //   cellRenderer: (props: any) => {
  //     return renderNA(props.data.category.name);
  //   },
  // };
  const IndustryCategory: ColDef = {
    ...generateColumn("Category", "category.name"),
    cellRenderer: (props: any) => {
      return renderNA(props?.data?.category?.name);
    },
    filterValueGetter: (props: any) => {
      return renderNA(props?.data?.category?.name);
    },
    tooltipValueGetter: (props: any) => {
      return renderNA(props?.data?.category?.name);
    },
    valueGetter: (props: any) => {
      return props?.data?.category?.name;
    },
  };




  return [
    idColumn,
    IndustryNameColumn,
    IndustryCategory,
    {
      ...generateColumn("Description", "description"),
      ...textFormatEditor("description"),
    },
    {
      field: "show_status",
      headerName: "Visible Status",
      cellRenderer: (props: any) => {
        return renderNA(props.data.show_status);
      },
    },
    
    statusColumn,
    actionColumn,
  ];
};

export default useColumnDefs;
